module.exports = {
  pleaseWait: 'សូមរង់ចាំ',
  FAQ: 'សំណួរដែលសួរញឹកញាប់',
  FAQs: 'សំណួរដែលសួរញឹកញាប់',
  TC: 'លក្ខខណ្ឌ',
  Login: 'ចូលគណនី',
  getCode: 'ផ្ញើOTP',
  loginTips: 'បញ្ចូលលេខទូរស័ព្ទរបស់អ្នក',
  otpTips: 'សូមបញ្ចូលលេខសម្ងាត់ OTP',
  phoneNumber: 'លេខទូរស័ព្ទ',
  select_package: 'សូមជ្រើសរើសកញ្ចប់',
  daily_package: 'កញ្ចប់ប្រចាំថ្ងៃ',
  weekly_package: 'កញ្ចប់ប្រចាំសប្តាហ៍',
  monthly_package: 'កញ្ចប់ប្រចាំខែ',
  chances_2_day: 'ឱកាសលេងហ្គេម 5ដង/ថ្ងៃ',
  chances_14_day: 'ឱកាសលេងហ្គេម 35ដង/ 7 ថ្ងៃ',
  chances_60_day: 'ឱកាសលេងហ្គេម 5ដង/ថ្ងៃ សរុបឱកាស 150ដង',
  free_first_sub: 'ឥតគិតថ្លៃសម្រាប់ការភ្ជាប់កញ្ចប់ប្រចាំថ្ងៃលើកដំបូង',
  chances_2_day_Validity: 'សុពលភាព៖ 1 ថ្ងៃ',
  chances_14_day_Validity: 'សុពលភាព៖ 7 ថ្ងៃ',
  chances_60_day_Validity: 'សុពលភាព៖ 30 ថ្ងៃ',
  Register: 'ភ្ជាប់',
  need_esim_prefix: 'ត្រូវការស៊ីមសែលកាតមែនទេ?',
  get_esim: 'ទិញ eSIM ឥឡូវនេះ',
  otp_confirm_title: 'បញ្ជាក់ការភ្ជាប់កញ្ចប់',
  confirm: 'បញ្ជាក់',
  cancel: 'បោះបង់',
  loadMore: 'អូសឡើងលើដើម្បីមើលបន្ថែម',
  loadMore2: 'មិនមានទិន្នន័យទេ',
  Subscribe: 'ភ្ជាប់',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js